declare var katex: any;

import * as franc from 'franc';


const header = 'elp_plus_';
const baseUrl = 'https://my.hadaf.edu.pk/api/';
// const baseUrl = 'http://localhost:5020/api/';
const baseUrlems = 'https://ems.pgc.edu.pk/api/';

//const baseUrl = window.location.origin.toLowerCase().indexOf('hadaf') > -1 ? 'https://my.hadaf.edu.pk/api/' : 'https://my.hadaf.edu.pk/api/';

const operation = {
    getAll: 'GetAll',
    find: 'FindBy',
    insert: 'Insert',
    update: 'Update',
    delete: 'Delete',
};

const config = {
    tokenName: header + 'authentication',
    classLevl: header + 'class_level_id_storage',
    selectedWork: header + 'selected_work',
    buttonState: header + 'button_state',
    dailyQuestion: header + 'daily_attempt',
    isM: header + 'is_medical',
    deviceId: header + 'device_id',
    username: header + 'username',
    programSelect: header + 'program',
    fbLogin: header + 'fb_login',
    userInfo: header + 'user_info',
    userInfoEMS: header + 'class_level_id_cms',
    macAddress: header + 'mac_address',
    isPre: header + 'is_pre_user',
    isPre2: header + 'is_pre_second_batch',
    selectedSubjectName: header + 'selected_subject_name',
    firstLogin: header + 'first_login',
    notificationLast: header + 'notification_last_time_stamp',
    dayModal: header + 'day_modal',
    classState: header + 'class_state',
    userLogCheck: header + 'user_log',
    sessionId: header + 'session_id',
    sessionIdTime: header + 'session_id_time',
    currentIpAddress: header + 'ip_address',
    todaySurvey: header + 'today_survey',
    admissionId: header + 'admission_id',
    studentPartInfo: header + 'student_part_info',
    connection: header + 'connection_id',
    isPre3: header + 'is_pre_third_batch',
    isPre4: header + 'is_pre_fourth_batch',
    isPre5: header + 'is_pre_fifth_batch',
    isPre6: header + 'is_pre_sixth_batch',
    isTestSession: header + 'is_test_session',
    isTestSession3: header + 'is_test_session_3',
    isTestSession4: header + 'is_test_session_4',
    isTestSession5: header + 'is_test_session_5',
    isTestSession6: header + 'is_test_session_6',
    userBatch: header + 'user_batch',
    getBindProgram: baseUrl + 'Work/GetBindProgram',
    getDialog: baseUrl + 'Work/GetDialog',
    getSchema: baseUrl + 'Work/GetSos',
    firstDayWeek: header + 'first_day_week',
    firstWorkDate: header + 'first_day_date',
    lastWorkDate: header + 'last_work_date',
    getVideoToekn: baseUrl + 'VideoToken/GetVideoToken',
    selectedStepProgram: header + 'selected-step-program',


    sasKey: 'DefaultEndpointsProtocol=https;AccountName=elfileshare;AccountKey=dbTj2dCebD6zLal4TyZXBM0wP9ksDkcgNFOFAOC5WQ47RL+PXhVCdfFCG608B9KeGcPWmaPRItBA7dC7FqNbwA==;EndpointSuffix=core.windows.net',

    getStudentInfoEMS_Encrypt: baseUrlems + "Mobile/GetStudentProfileDB_Encrypt",
    getStudentInfoEMS: baseUrlems + 'Mobile/GetStudentProfileDB',
    getStaffCheck: baseUrlems + 'Mobile/GetStaffCheck',
    getStudentBoardInfo: baseUrlems + 'Mobile/StudentPortalBoardInfo',
    getTimetableEMS: baseUrlems + 'Mobile/get_timetable_reportWithClass',
    getAttendanceEMS: baseUrlems + 'Mobile/attendance_cms',
    getDetailAttendanceEMS: baseUrlems + 'Mobile/GetStudentAttDetailINfoEx',
    getOneMonthAttendance: baseUrlems + 'Mobile/student_attendance_monthly_single_month_wise',
    getExamEMS: baseUrlems + 'Mobile/StudentPortalGetExamTypeAll ',
    getExamDetailEMS: baseUrlems + 'Mobile/ExamResultStudentAppEx',
    getExamDetailEMSOld: baseUrlems + 'Mobile/ExamResultStudentApp',
    // getFeesEMS: baseUrlems + 'Mobile/students_fee_list',

    getprogressbar: baseUrlems + 'ELChapters/GetTrainingProgress',
    getcertificate: baseUrlems + 'ELChapters/GetCertificate',
    getTrainingCourses: baseUrlems + 'ELChapters/GetTrainings',
    getTrainingModules: baseUrlems + 'ELChapters/GetTrainingDetail',
    getTrainingVideosContent: baseUrlems + 'ELChapters/GetTrainingContent',
    getTrainingQuiz: baseUrlems + 'ELChapters/GetTraningQuiz',
    gettrainingquiz: baseUrlems + 'ELChapters/GetTraningQuiz',
    trainiguseractionlog: baseUrlems + 'ELChapters/TraningUserActionLog',
    getprofileactionlog: baseUrlems + 'ELChapters/TraningUserActionLog',
    submitquiztraining: baseUrlems + 'ELChapters/TraningSaveQuiz',
    getFeesEMS: baseUrlems + 'Mobile/students_fee_list_DueDateCalculate',
    getNotifications: baseUrlems + 'Mobile/GetStudentNotification',
    getStagingNotifications: baseUrlems + 'Mobile/GetStudentNotification',
    getAcademicCalendar: baseUrlems + 'Mobile/StudentCalendarApiEx',
    getStudentAcademicCalendar: baseUrlems + 'Mobile/StudentAcedemicCalendarApiMobileApp',
    getStudentQuestions: baseUrlems + 'Mobile/GetStudentQuestion',
    pushSurvey: baseUrlems + 'Mobile/DailySurveyNotification',
    getMandatorySurvey: baseUrlems + 'PublicDashBoard/GetSurveyDetail2',
    insertMandatorySurvey: baseUrlems + 'PublicDashBoard/InsertSurvey',
    getQuestionWA: baseUrl + 'Step/GetQuestionsWA',
    sendQuestion: baseUrlems + 'Mobile/send_question',
    sendQuestionEx: baseUrlems + 'Mobile/send_questionEx',
    getStudentChat: baseUrlems + 'Mobile/GetStudentChatWithTeacher',
    getVocabExtended: baseUrl + 'VocabularyExtended/GetGroups',
    getAllExamResult: baseUrlems + 'Mobile/StudentPortalGetAllExamsResultNew',
    getActionLogs: baseUrlems + 'ELChapters/GetActionLogs',

    // ARVO / EL endpoints
    getmcqArvoChapters: baseUrlems + 'ELChapters/GetSubjectsByPeogramCombo',
    getmcqOldChapters: baseUrlems + 'ELChapters/GetSubjectsByPeogramComboNew',
    getQuestionsWAnswersArvo: baseUrlems + 'ELChapters/GetARVOContentWeb',
    getQuestionsWAnswersPGC: baseUrlems + 'ELChapters/GetARVOContentOldVideo',
    getQuestionsWAnswersB: baseUrlems + 'ELChapters/GetARVOContentCreatTest',
    getarvosmartChapters: baseUrlems + 'ELChapters/GetArvoSmartLChaptersContent',
    getarvosmartVideoContent: baseUrlems + 'ELChapters/GetArvoSmartLVideoContent',
    getARVOSetupTags: baseUrlems + 'ELChapters/GetARVOSetupTags',
    getVideoQuestionsArvo: baseUrlems + 'ELChapters/GetARVOTopicQuestion',
    getArvoTopicVideos: baseUrlems + 'ELChapters/GetAcademicCalendarARVOContent',
    getShortQuestionsArvo: baseUrlems + 'ELChapters/GetARVOTopicShortQuestion',
    expandTopicView: baseUrlems + 'ELChapters/GetARVOTopicViewApi',
    getEbooks: baseUrlems + 'ELChapters/GetARVOEbooksNew',
    getsubjectlistData: baseUrlems + 'Quiz/GetQuizStatus',

    // MCQ response storage (updated to ARVO endpoints)
    getSheetAnswers: baseUrlems + 'UserMcqResponse/GetMcqResponse',
    getSheetAnswersPast: baseUrl + 'UserMcqResponse/GetAllBoard',
    insertSheetAnswers: baseUrlems + 'UserMcqResponse/AddOne',
    updateSheetAnswers: baseUrlems + 'UserMcqResponse/Update',
    insertMcq: baseUrlems + 'UserMcqResponse/InsertMCQAttempted',
    insertTW: baseUrlems + 'Mobile/InsertTopicWatch',

    // Quiz endpoints
    pGCQuizStatus: baseUrlems + 'PublicDashBoard/PGCQuizStatus',
    NegativeVideoRatting: baseUrlems + 'Mobile/NegativeVideoRatting',
    ratingSave: baseUrlems + 'Mobile/SaveRating',
    ratingSaveList: baseUrlems + 'Mobile/SaveRatingList',
    GetPgcVideoRating: baseUrlems + 'Mobile/GetVideoRating',
    leaguename: baseUrlems + 'Quiz/GetActiveLeagueData',
    getcourselist: baseUrlems + 'Quiz/GetQuizCourseListEncrypt',
    getquizlastlist: baseUrlems + 'Quiz/GetLastTimeEncrypt',
    getquizquestionlist: baseUrlems + 'Quiz/GetRandomQuestionByCourseEncrypt',
    getquizlist: baseUrlems + 'Quiz/GetQuizConfigrationDataEncrypt',
    getquiztimeupdlist: baseUrlems + 'Quiz/QuizTimeUpdateEncrypt',
    getquizsubmit: baseUrlems + 'Quiz/SubmitQuizEncrypt',
    getquizsubmitnull: baseUrlems + 'Quiz/SubmitQuizInNullCaseEncrypt',
    getLeaderBoardListtinfo: baseUrlems + 'Quiz/GetLeaderBoardSubjectWise',
    getResultIndivalWise: baseUrlems + 'Quiz/GetLeagueDataofTopStudents',
    setgreakDowndATA: baseUrlems + 'Quiz/QuizBreakdownOfStudent',
    getBreakDownDatagetMyPerfocmceapi: baseUrlems + 'Quiz/QuizStudentDataPerformance',
    getTotalResultList: baseUrlems + 'Quiz/TotalMarksQuizWize',
    getQuizFinishedList: baseUrlems + 'Quiz/QuizFinishedList',
    getQuizAllDoneOverAll: baseUrlems + 'Quiz/QuizAllDoneOverAll',

    getVideoTopics: baseUrl + 'General/GetUserTopics',
    setVideoTopicEnable: baseUrl + 'General/UpdateTopicWatchEnableMcq',
    getVideoQuestions: baseUrl + 'General/GetQuestionWAnswersVx',
    updateTopicMarks: baseUrl + 'General/UpdateTopicWatchEnableMcqMarks',
    getTopicMarks: baseUrl + 'General/GetTopicWatchMcqMarks',
    getBoards: baseUrl + 'General/GetBoards',
    getBoardPrograms: baseUrl + 'General/GetBoardPrograms',
    getBoardProgramsEx: baseUrl + 'General/GetBoardProgramsEx',
    getAllWork: baseUrl + 'Work/WorkDayBatch',
    getVideos: baseUrl + 'Work/WorkVideos',
    getMCQs: baseUrl + 'Work/WorkMcqs',
    getNotes: baseUrl + 'Work/WorkNotes',
    logUser: baseUrl + 'Users/LoginLog',
    getWorkX: baseUrl + 'WorkEx/WorkOneX',
    getWork: baseUrl + 'WorkEx/WorkOne',
    getTest: baseUrl + 'WorkEx/GetTest',
    getQuestionsWAnswers: baseUrl + 'General/GetQuestionWAnswers',
     getQuestionsWAnswersAlt: baseUrl + 'General/GetQuestionWAnswersBQtype',

    loginDirect: baseUrl + 'Users/UserLogin',
    loginExternal: baseUrl + 'ExternalAuth/LoginEx',

    roleBaseMenu: 'General/GetUserRole',
    loginUser: baseUrl + 'Users/' + operation.find,

    userProgram: 'General/GetUserProgram',
    getUserProgram: baseUrl + 'General/GetUserProgram',
    userClass: 'General/GetUserClass',
    getUserClass: baseUrl + 'General/GetUserClass',
    userSubjects: 'General/GetUserSubjects',
    getUserSmartSubjects: baseUrl + 'General/GetUserSlSubjects',
    getUserSmartChapters: baseUrl + 'General/GetUserSlChapters',
    getUserSmartTopics: baseUrl + 'General/GetUserSlTopics',
    getUserSmartChapterTopics: baseUrl + 'General/GetChapterTopics',
    getUserSmartChapterTopicsEx: baseUrl + 'General/GetUserSlChaptersTopics',
    getUserSubjects: baseUrl + 'General/GetUserSubjects',
    getMUserSubjects: baseUrl + 'General/GetUserMSubjects',
    getCUserSubjects: baseUrl + 'General/GetUserCSubjects',
    userChapters: 'General/GetUserChapters',
    getUserChapters: baseUrl + 'General/GetUserChapters',
    userTopics: 'General/GetUserTopics',
    getUserTopics: baseUrl + 'General/GetUserTopics',
    chapterTopics: 'General/GetChapterTopicsVimeo',
    getChapterTopics: baseUrl + 'General/GetChapterTopicsVimeo',
    userPpSubjects: 'General/GetUserPpSubjects',
    getUserPPSubjects: baseUrl + 'General/GetUserPpSubjects',

    mcqSubject: 'General/GetUserSubjects',
    getMcqSubject: baseUrl + 'General/GetUserSubjects',
    mcqChapter: 'General/GetMcqChapters',
    getMcqChapter: baseUrl + 'General/GetMcqChaptersEXx',
    mcqTopcs: 'General/GetMcqTopics',
    getMcqTopics: baseUrl + 'General/GetMcqTopics',

    getsubjectlist: 'General/getsubjectlist',

    assSubject: 'General/GetAssSubjects',
    assChapter: 'General/GetAssChapters',
    assTopcs: 'General/GetAssTopics',

    classVideo: 'General/GetClassVideo',
    classAss: 'General/GetClassAss',
    classMcq: 'General/GetClassMcq',

    assCount: 'General/GetAssCount',

    topicQuestions: 'Assess/QuestionBy',
    getTopicQuestions: baseUrl + 'Assess/QuestionBy',
    questionAnswer: 'Assess/AnswerBy',
    getQuestionAnswer: baseUrl + 'Assess/AnswerBy',

    // (insertTW and insertMcq are now defined above in the ARVO section)

    allQuestions: 'General/GetAllQuestions',

    chapterQuestions: 'General/GetChapterQuestions',
    GetChapterQuestions: baseUrl + 'General/GetChapterQuestions',

    allBoards: 'General/GetAllBoards',
    getAllBoards: baseUrl + 'General/GetAllBoards',
    className: 'General/GetSelectedClass',
    getPdf: baseUrl + 'General/GetPaperPath',
    // getVideoToekn: baseUrl +  'VideoToken/GetVideoToken',
    getrating: baseUrl + 'General/getrating',
    getratingSave: baseUrl + 'General/getratingSave',

    chaptersmaxwatchedavergae: 'General/GetChaptersmaxwatchedavergae',
    chaptersmaxwatchedavergaesubjectwise: 'General/chaptersmaxwatchedavergaesubjectwise',

    chaptersmaxattemptedavergae: 'General/GetChaptersmaxattemptedavergae',
    chaptersmaxattemptedavergaebysubject: 'General/chaptersmaxattemptedavergaebysubject',

    facebookLink: 'General/FacebookLink',
    getpastpapers: baseUrl + 'General/Getpastpapers',

    postlink: 'General/postlink',
    getlink: 'General/getlink',

    mcqspostlink: 'General/mcqspostlink',
    mcqsgetlink: 'General/mcqsgetlink',

    modelPaperGet: 'ModelPaper/GetModelPapers',
    modelPaperAGet: 'ModelPaper/GetModelPapersAttemp',

    saveDailyQuestion: baseUrl + 'General/savedailyquestion',
    setDailyQuestion: baseUrl + 'General/setdailyquestion',
    getDailyQuestion: baseUrl + 'General/getdailyquestion',
    getGlobalStatistics: baseUrl + 'General/getglobalstatistics',

    subjectSetsAll: baseUrl + 'SubjectSets/GetAll',
    subjectTestfind: baseUrl + 'SubjectTest/FindByEx',

    processFb: baseUrl + 'General/processfacebook',

    getDayWorkEx: baseUrl + 'Step/WorkOneNew',
    getTestStep: baseUrl + 'Step/GetTest',
    getQuestionsExam: baseUrl + 'Step/GetQuestionsExtended',
    getResultExam: baseUrl + 'Step/GetExamResult',
    updateAnswerExam: baseUrl + 'Step/InsertOrUpdateAnswer',
    resetTest: baseUrl + 'Step/ResetQuestions',
    getWorkSheet: baseUrl + 'Step/GetWorkSheet',
    getWorkDayId: baseUrl + 'Step/WorkBatch',
    getTokenWebsite: 'auth/TokenWebSite', // example


    createGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },

    checkLang(str) {
        var lst = ['und', 'urd', 'fas', 'pes', 'skr', 'arb', 'uig'];
        var lan = franc(str, { minLength: 3 });

        return lst.indexOf(lan) > -1;
    },

    extractHTML(html) {
        let sources = [];
        if (html) {
            const val = html.match(/img [^>]*src="[^"]*"[^>]*>/gm);
            if (val)
                sources = html.match(/img [^>]*src="[^"]*"[^>]*>/gm).map(x => x.replace(/.*src="([^"]*)".*/, '$1'));
            if (sources && sources[0]) {
                let returnVal = ""
                for (let i = 0; i < sources.length; i++) {
                    returnVal += "<img src='" + sources[i] + "'/>";
                }
                return returnVal
            }

        } else {
            return null
        }
    },

    renderHTML(providedText) {
        if (providedText.indexOf('<lat>') !== -1) {
            const result = providedText.match(/<lat>(.*?)<\/lat>/g);

            for (let e of result) {
                try {
                    providedText = providedText.replace(e.trim(),
                        katex.renderToString(e.trim().replace(/<\/?lat>/g, '')));
                } catch (exc) {
                    console.error(exc + ' @ ' + e);
                }
            }
            return providedText;
        } else {
            return providedText.trim();
        }
    },
};

export default config;
